import { Typography } from "antd";
import { Trans } from "react-i18next";

const { Paragraph } = Typography;

export const SchemaBuilderExpressionHint = () => {
  return (
    <div className="schema-builder-expression-hint">
      <Trans parent={Paragraph} i18nKey="schema:expression.hint.1" />
      <Trans parent={Paragraph} i18nKey="schema:expression.hint.2" />
      <Trans parent={Paragraph} i18nKey="schema:expression.hint.3" />
      <Trans parent={Paragraph} i18nKey="schema:expression.hint.4" />
    </div>
  );
};
